export var PrimaryMarket_IPO = "PrimaryMarket_IPO";
export var UPDATE_UPCOMING_DATA = "UPDATE_UPCOMING_DATA";
export var PrimaryMarket_IPO_ADD_MSG = "PrimaryMarket_IPO_ADD_MSG";
export var PrimaryMarket_IPO_CLEAR_MSG = "PrimaryMarket_IPO_CLEAR_MSG";
export var PrimaryMarket_IPO_ERROR = "PrimaryMarket_IPO_ERROR";
export var PrimaryMarket_IPO_HIDE_ERROR = "PrimaryMarket_IPO_HIDE_ERROR";
export var PrimaryMarket_IPO_START_LOADER = "PrimaryMarket_IPO_START_LOADER";
export var PrimaryMarket_IPO_STOP_LOADER = "PrimaryMarket_IPO_STOP_LOADER";
